import {isFeatureEnabled} from '@github-ui/feature-flags'
import {sendStats} from '@github-ui/stats'
import {type ProfilerOnRenderCallback, useCallback, version} from 'react'

export function useAppScopedProfilerCollector({
  appName,
  isDataRouterEnabled,
}: {
  appName: string
  isDataRouterEnabled: boolean
}) {
  const onRender: ProfilerOnRenderCallback = useCallback(
    (id, phase, actualDuration, baseDuration, startTime, commitTime) => {
      if (typeof window === 'undefined' || !isFeatureEnabled('react_quality_profiling')) {
        return
      }

      sendStats({
        requestUrl: window.location.href,
        reactRenderPerformance: {
          actualDuration,
          baseDuration,
          commitLag: commitTime - startTime,
          phase,
          appName,
          isDataRouterEnabled,
          componentId: id,
          reactVersion: version,
        },
      })
    },
    [appName, isDataRouterEnabled],
  )

  return {onRender}
}
